import { V1CronJob, V1DaemonSet, V1Deployment, V1Job, V1PodSpec, V1StatefulSet } from "@kubernetes/client-node"
import { OperateFunction } from "yam-types"
import { Settings } from "../settings.d"
import { AppLogging } from "../types.d"

const loggingOperator: OperateFunction<AppLogging> = async (plan, diff, settings: Settings) => {
  if (diff.currentItems.length === 0 || Object.keys(diff.currentItems[0]).length === 0) {
    return
  }
  const logBasePathOnHost = settings.hostLogPath || `/data/logs/${plan.data.namespace}/${plan.data.app}`
  const logExpression = settings.hostLogSubPathExpr || "$(APP_POD_NAME)"
  const logBasePathInContainer = diff.currentItems[0]?.basePath

  const deploySpec = plan.data.currentModelFull.deploy
  const logVolumeName = plan.data.app + '-log-path'
  if (logBasePathInContainer && deploySpec) {
    plan.action(async (ctx) => {
      const data = ctx.managedK8SResources.get(plan.data.workloadName) as V1Deployment | V1StatefulSet | V1DaemonSet | V1Job
      if (!data) {
        ctx.log.warn("can not inject log path because no workloads deployed")
        return
      }
      const podSpec = (data.spec?.template.spec || (data as V1CronJob).spec?.jobTemplate.spec?.template.spec) as V1PodSpec
      if (!podSpec) {
        ctx.log.warn("can not inject log path because no pod spec found")
        return
      }

      // check if need to inject chmod container
      if (settings.injectCheckLogPermissionInitContainer) {
        podSpec.initContainers?.unshift({
          name: "init-log-path",
          image: settings.injectCheckLogPermissionInitContainer,
          command: ['sh', '-c', `chmod -R a+wx ${logBasePathInContainer}`],
          env: [{
            name: 'APP_POD_NAME',
            valueFrom: {
              fieldRef: {
                apiVersion: 'v1',
                fieldPath: 'metadata.name'
              }
            }
          }]
          // volumeMount will be automatically injected in next merge yaml stage
        })
        ctx.log.info(`inject init container for chmod log path: ${logBasePathInContainer}`)
      }

      if (!podSpec.volumes) {
        podSpec.volumes = []
      }
      podSpec.volumes.push({
        name: logVolumeName,
        hostPath: {
          path: logBasePathOnHost,
          type: "DirectoryOrCreate"
        }
      })

      const containers = podSpec.containers.concat(podSpec.initContainers || [])
      for (const container of containers) {
        if (!container.volumeMounts) {
          container.volumeMounts = []
        }
        container.volumeMounts.push({
          name: logVolumeName,
          mountPath: logBasePathInContainer,
          subPathExpr: logExpression
        })
      }


    }, `append-log-mount:${logBasePathInContainer}`)
  }
}

export default loggingOperator